<template>
    <div class="view">
        <h2>Postés ajoutés à la synthèse à valider, modifier ou supprimer</h2>

        <b-card header="Filtres de recherche" class="mb-3 mt-5">
            <b-row>
                <b-col>
                    <b-form-group
                            label="Code ROME"
                            id="input-group-code"
                            label-for="input-code">
                        <b-form-input
                                id="input-group-code"
                                v-model="code.code"
                                type="text"
                                @input="onFilterChange"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                            label="Libellé"
                            id="input-group-libelle"
                            label-for="input-libelle">
                        <b-form-input
                                id="input-group-libelle"
                                v-model="code.libelle"
                                type="text"
                                @input="onFilterChange"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                            label="Typologie de poste"
                            id="input-group-type"
                            label-for="type">
                        <b-form-select
                                id="type"
                                v-model="code.type"
                                :options="typologies"
                                @change="search">
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    <b-form-group
                            label="Présent dans le référentiel Pôle emploi"
                            id="input-group-poleEmploi"
                            label-for="poleEmploi">
                        <b-form-select
                                id="poleEmploi"
                                v-model="code.poleEmploi"
                                :options="ouiNonOptions"
                                @change="search">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group
                            label="Vérifié"
                            id="input-group-verifie"
                            label-for="verifie">
                        <b-form-select
                                id="verifie"
                                v-model="code.verifie"
                                :options="ouiNonOptions"
                                @change="search">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                            label="Combinaison typo/code ROME/libellé à valider"
                            id="input-group-customType"
                            label-for="customType">
                        <b-form-select
                                id="customType"
                                v-model="code.customType"
                                :options="ouiNonOptions"
                                @change="search">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group
                            label="Présent dans la synthèse"
                            id="input-group-presentSynthese"
                            label-for="presentSynthese">
                        <b-form-select
                                id="presentSynthese"
                                v-model="code.presentSynthese"
                                :options="ouiNonOptions"
                                @change="search">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4" offset="4" class="d-flex justify-content-center">
                    <b-button variant="primary" @click="resetFilters">Réinitialiser les filtres</b-button>
                </b-col>
            </b-row>
        </b-card>

        <b-row class="mt-3">
            <b-col class="text-center">
                <b-button type="button" variant="primary"
                          @click="showModalAddPoste">
                    Ajouter un nouveau poste
                </b-button>
            </b-col>
            <b-modal
                    id="modal-add-poste"
                    title="Ajouter un nouveau poste"
                    ok-title="Confirmer"
                    cancel-title="Annuler"
                    hide-footer
                    @hidden="search">
                <CreerCodeRome :codeRome="newCodeRome" :referentielView="true"></CreerCodeRome>
            </b-modal>
        </b-row>

        <div class="pt-5" v-if="codesResult">
            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                                v-model="pageSize"
                                :options="pageSizes"
                                @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                                v-model="pageIndex"
                                :total-rows="codesResult.totalElements"
                                :per-page="pageSize"
                                :limit="10"
                                align="center"
                                @input="search()"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="codesTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                        </div>
                    </template>
                    <template v-slot:cell(createdBy)="row">
                        <b-button size="sm" v-b-tooltip.hover :title="row.item.createdBy">
                            <Icon icon="info-circle" size="1x"></Icon>
                        </b-button>
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" v-b-modal="'modal-edit' + row.item.id">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-edit' + row.item.id"
                                title="Modification de code ROME"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                hide-footer
                                @hidden="search"
                                @ok="preventOk">
                            <ModifierCodeRome
                                    :value="row.item"
                                    :modalId="'modal-edit' + row.item.id"
                            ></ModifierCodeRome>
                        </b-modal>
                    </template>
                    <template v-slot:cell(validate)="row">
                        <b-button size="sm" v-b-modal="'modal-validate' + row.item.id"
                                  :disabled="!(row.item.verifie === false || row.item.customType === true)">
                            <Icon icon="check-square" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-validate' + row.item.id"
                                title="Validation de code ROME"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="validerCode(row.item)">
                            <p>Confirmez-vous la validation de ce code ROME ?</p>
                        </b-modal>
                    </template>
                    <template v-slot:cell(remove)="row">
                        <b-button size="sm" v-b-modal="'modal-remove' + row.item.id"
                                  :disabled="!row.item.presentSynthese">
                            <Icon icon="minus-square" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-remove' + row.item.id"
                                title="Retrait du poste"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="removePosteFromSynthese(row.item)">
                            <p>Vous allez supprimer ce poste. Il n'apparaîtra plus dans la synthèse, voulez-vous
                                continuer ?</p>
                        </b-modal>
                    </template>
                    <template v-slot:cell(delete)="row">
                        <b-button size="sm" v-b-modal="'modal-delete' + row.item.id">
                            <Icon icon="trash" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-delete' + row.item.id"
                                title="Suppression du poste"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="deletePoste(row.item)">
                            <p>Vous allez supprimer ce poste du référentiel des codes ROME, voulez-vous continuer ?</p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>

    </div>
</template>

<script>

  import CodeRomeStore from "../../stores/CodeRomeStore";
  import AlertStore from "../../stores/AlertStore";
  import ModifierCodeRome from "./ModifierCodeRome";
  import CreerCodeRome from "./CreerCodeRome";
  import {TypologiePosteEnum} from "../../constants/enums";
  import CodeRomeDto from "../../dtos/CodeRomeDto";
  import _ from 'lodash';

  export default {
    components: {ModifierCodeRome, CreerCodeRome},
    data() {
      return {
        code: new CodeRomeDto(),
        newCodeRome: null,
        typologies: Object.entries(TypologiePosteEnum).map((value) => {
          return {text: value[1], value: value[0]};
        }),
        ouiNonOptions: [{text: '', value: null}, {text: 'Oui', value: true}, {text: 'Non', value: false}],
        codesResult: null,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        fields: [
          {label: '', key: 'num', sortable: false},
          {label: 'Code', key: 'code', sortable: true},
          {label: 'Libellé', key: 'libelle', sortable: true},
          {label: 'Type', key: 'typeLibelle', sortable: true},
          {label: 'Créé par', key: 'createdBy', sortable: false},
          {label: 'Consulter / Modifier', key: 'edit', sortable: false},
          {label: 'Valider', key: 'validate', sortable: false},
          {label: 'Retirer synthèse', key: 'remove', sortable: false},
          {label: 'Supprimer', key: 'delete', sortable: false}
        ]
      }
    },
    computed: {
      codesTable: function () {
        return this.codesResult.content.map(code => {
          return {
            id: code.id,
            code: code.code,
            libelle: code.libelle,
            type: code.type,
            createdBy: code.createdBy,
            typeLibelle: TypologiePosteEnum[code.type],
            poleEmploi: code.poleEmploi,
            verifie: code.verifie,
            presentSynthese: code.presentSynthese,
            customType: code.customType,
          }
        });
      }
    },
    mounted() {
      this.initPagination();
      this.resetFilters();
    },
    methods: {
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        this.sortOptions = [{sortBy: 'code', sortDirection: 'asc'}];
      },
      showModalAddPoste() {
        this.newCodeRome = new CodeRomeDto();
        this.$bvModal.show('modal-add-poste');
      },
      onFilterChange: _.debounce(function () {
        this.search();
      }, 1000),
      resetFilters() {
        this.code = new CodeRomeDto;
        this.code.verifie = false;
        this.code.customType = true;
        this.code.presentSynthese = true;
        this.search();
      },
      search() {
        CodeRomeStore.search(this.code, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.codesResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      preventOk(evt) {
        evt.preventDefault();
      },
      validerCode(code) {
        code.presentSynthese = true;
        CodeRomeStore.update(code, 'validé').then(() => {
          this.search();
        });
      },
      removePosteFromSynthese(code) {
        code.presentSynthese = false;
        CodeRomeStore.update(code, 'supprimé de la synthèse').then((value) => {
          if (value) {
            this.search();
          }
        });
      },
      deletePoste(code) {
        CodeRomeStore.delete(code.id).then(() => {
          this.search();
        });
      }
    }
  }
</script>
